import { render, staticRenderFns } from "./baseline.vue?vue&type=template&id=3b48a864&"
import script from "./baseline.vue?vue&type=script&lang=js&"
export * from "./baseline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports